import Pendencias from './Pendencias';

export default Pendencias;
